import {
  ComponentBase_default
} from "./chunk-2DCYBCRT.js";
import "./chunk-D5JVWJXO.js";
import {
  init_shim
} from "./chunk-XJTZ422K.js";

// node_modules/phaser3-rex-plugins/plugins/input/button/Button.js
init_shim();
var GetValue = Phaser.Utils.Objects.GetValue;
var Button = class extends ComponentBase_default {
  constructor(gameObject, config) {
    super(gameObject, config);
    this._enable = void 0;
    gameObject.setInteractive(GetValue(config, "inputConfig", void 0));
    this.resetFromJSON(config);
    this.boot();
  }
  resetFromJSON(o) {
    this.pointer = void 0;
    this.lastClickTime = void 0;
    this.setEnable(GetValue(o, "enable", true));
    this.setMode(GetValue(o, "mode", 1));
    this.setClickInterval(GetValue(o, "clickInterval", 100));
    this.setDragThreshold(GetValue(o, "threshold", void 0));
    return this;
  }
  boot() {
    var gameObject = this.parent;
    gameObject.on("pointerdown", this.onPress, this);
    gameObject.on("pointerup", this.onRelease, this);
    gameObject.on("pointerout", this.onPointOut, this);
    gameObject.on("pointermove", this.onMove, this);
    gameObject.on("pointerover", this.onOver, this);
    gameObject.on("pointerout", this.onOut, this);
  }
  shutdown(fromScene) {
    if (this.isShutdown) {
      return;
    }
    this.pointer = null;
    super.shutdown(fromScene);
  }
  get enable() {
    return this._enable;
  }
  set enable(e) {
    if (this._enable === e) {
      return;
    }
    if (!e) {
      this.cancel();
    }
    this._enable = e;
    var eventName = e ? "enable" : "disable";
    this.emit(eventName, this, this.parent);
  }
  setEnable(e) {
    if (e === void 0) {
      e = true;
    }
    this.enable = e;
    return this;
  }
  toggleEnable() {
    this.setEnable(!this.enable);
    return this;
  }
  setMode(m) {
    if (typeof m === "string") {
      m = CLICKMODE[m];
    }
    this.mode = m;
    return this;
  }
  setClickInterval(interval) {
    this.clickInterval = interval;
    return this;
  }
  setDragThreshold(distance) {
    this.dragThreshold = distance;
    return this;
  }
  // internal
  onPress(pointer, localX, localY, event) {
    if (this.pointer !== void 0) {
      return;
    }
    this.pointer = pointer;
    if (this.mode === 0) {
      this.click(pointer.downTime, pointer, event);
    }
  }
  onRelease(pointer, localX, localY, event) {
    if (this.pointer !== pointer) {
      return;
    }
    if (this.mode === 1) {
      this.click(pointer.upTime, pointer, event);
    }
    this.pointer = void 0;
  }
  onPointOut(pointer, event) {
    if (this.pointer !== pointer) {
      return;
    }
    this.cancel();
  }
  onMove(pointer, localX, localY, event) {
    if (this.pointer !== pointer) {
      return;
    }
    if (this.dragThreshold === void 0) {
      return;
    }
    if (pointer.getDistance() >= this.dragThreshold) {
      this.cancel();
    }
  }
  click(nowTime, pointer, event) {
    if (!this.enable) {
      return this;
    }
    if (nowTime === void 0) {
      this.emit("click", this, this.parent, pointer, event);
      return this;
    }
    this.pointer = void 0;
    var lastClickTime = this.lastClickTime;
    if (lastClickTime !== void 0 && nowTime - lastClickTime <= this.clickInterval) {
      return this;
    }
    this.lastClickTime = nowTime;
    this.emit("click", this, this.parent, pointer, event);
    return this;
  }
  cancel() {
    this.pointer = void 0;
    return this;
  }
  onOver(pointer, localX, localY, event) {
    if (!this.enable) {
      return this;
    }
    this.emit("over", this, this.parent, pointer, event);
    return this;
  }
  onOut(pointer, event) {
    if (!this.enable) {
      return this;
    }
    this.emit("out", this, this.parent, pointer, event);
    return this;
  }
};
var CLICKMODE = {
  press: 0,
  pointerdown: 0,
  release: 1,
  pointerup: 1
};
var Button_default = Button;
export {
  Button_default as default
};
